import { render } from "./changePassword.vue?vue&type=template&id=82ce227c"
import script from "./changePassword.vue?vue&type=script&lang=js"
export * from "./changePassword.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__